import {
  appendConfigText,
  createConfigElement,
  createConfigStatus,
  formatConfigTime,
  replaceConfigChildren,
} from './product-research-config-dom.js';

export function statusClassFor(status) {
  return {
    running: 'pr-config-status-info',
    queued: 'pr-config-status-muted',
    completed: 'pr-config-status-ok',
    success: 'pr-config-status-ok',
    partial: 'pr-config-status-warning',
    failed: 'pr-config-status-error',
    cancelled: 'pr-config-status-muted',
    cancel_requested: 'pr-config-status-warning',
    circuit_open: 'pr-config-status-error',
  }[status] || 'pr-config-status-muted';
}

function canCancelMirror(status) {
  return status === 'queued' || status === 'running';
}

export function createConfigJobCard(run, { mirror = false } = {}) {
  const card = createConfigElement('div', 'pr-config-job-card');
  const head = createConfigElement('div', 'pr-config-job-head');
  const title = createConfigElement('div');
  title.append(
    createConfigElement('strong', '', mirror ? `#${run?.id ?? '-'}` : run?.id || '-'),
    createConfigStatus(`${statusClassFor(run?.status)} pr-config-status-label`, run?.status || '-'),
  );
  head.append(title);

  if (mirror && canCancelMirror(run?.status)) {
    const actions = createConfigElement('div', 'pr-config-job-actions');
    const cancel = createConfigElement('button', 'btn btn-secondary', '取消');
    cancel.type = 'button';
    cancel.dataset.mirrorCancel = String(run?.id ?? '');
    actions.append(cancel);
    head.append(actions);
  }

  const meta = createConfigElement('div', 'pr-config-job-meta');
  if (mirror) {
    appendConfigText(meta, `${formatConfigTime(run?.created_at || run?.started_at)} · ${run?.site_code || '-'} · ${run?.run_mode || '-'} · 页 ${run?.page_count ?? 0} · ASIN ${run?.unique_asin_count ?? run?.item_count ?? 0}`);
  } else {
    const sites = (run?.site_codes || []).join(', ') || '-';
    const result = run?.result?.product?.results || [];
    const counts = result.map((item) => `${item.siteCode || item.site_code}:${item.resultCount ?? item.result_count ?? '-'}`).join(' · ');
    appendConfigText(meta, `${formatConfigTime(run?.created_at || run?.started_at)} · 策略 ${run?.strategy_code || '-'} · 站点 ${sites}`);
    if (counts) appendConfigText(meta, ` · 入库 ${counts}`);
  }
  if (run?.error_message) {
    appendConfigText(meta, ' · ');
    meta.append(createConfigStatus('pr-config-status-error', run.error_message));
  }
  card.append(head, meta);
  return card;
}

export function renderConfigCheckboxes(containerId, items, prefix, selectedCodes = null) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const selected = selectedCodes ? new Set(selectedCodes.map((code) => String(code).toUpperCase())) : null;
  replaceConfigChildren(container);
  items.forEach((item) => {
    const code = String(item.code || item.id || item).toUpperCase();
    const name = item.name || item.code || item.id || code;
    const label = createConfigElement('label', 'pr-config-check-option');
    const checkbox = createConfigElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = code;
    checkbox.dataset.prefix = prefix;
    if (selected) checkbox.checked = selected.has(code);
    label.append(checkbox, document.createTextNode(name));
    container.append(label);
  });
}

export function getConfigCheckedValues(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return [];
  return Array.from(container.querySelectorAll('input[type="checkbox"]:checked')).map((checkbox) => checkbox.value);
}

export function setConfigCheckedValues(containerId, codes) {
  const selected = new Set((codes || []).map((code) => String(code).toUpperCase()));
  const container = document.getElementById(containerId);
  if (!container) return;
  container.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
    checkbox.checked = selected.has(String(checkbox.value).toUpperCase());
  });
}
